var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "remove_red_eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5q1.422 0 2.461 1.039t1.039 2.461-1.039 2.461-2.461 1.039-2.461-1.039-1.039-2.461 1.039-2.461 2.461-1.039zM14 19.852q2.406 0 4.129-1.723t1.723-4.129-1.723-4.129-4.129-1.723-4.129 1.723-1.723 4.129 1.723 4.129 4.129 1.723zM14 5.25q4.32 0 7.82 2.406t5.031 6.344q-1.531 3.938-5.031 6.344t-7.82 2.406-7.82-2.406-5.031-6.344q1.531-3.938 5.031-6.344t7.82-2.406z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a1f26d52286bac1e06e99ae710c33909.svg";
export { ForwardRef as ReactComponent };